import { HTTP_TYPES } from '@/lib/enums'
import api from '@/api/api'

const API_VERSION = 'v2'

const response = {
  async getSectors(): Promise<any> {
    return await api(
      HTTP_TYPES.GET,
      `${import.meta.env.VITE_DEPOT_API_COMPANIES}/sectors`,
      undefined,
      undefined,
      'application/json',
      API_VERSION
    )
  },
  async postCreateSector(payload: any): Promise<any> {
    // name: string
    // mantle_uuid: guid

    return await api(
      HTTP_TYPES.POST,
      `${import.meta.env.VITE_DEPOT_API_COMPANIES}/sectors`,
      payload,
      undefined,
      'application/json',
      API_VERSION
    )
  },
  async deleteSector(sector_id: string): Promise<any> {

    return await api(
      HTTP_TYPES.DELETE,
      `${import.meta.env.VITE_DEPOT_API_COMPANIES}/sectors/${sector_id}`,
      undefined,
      undefined,
      'application/json',
      API_VERSION
    )
  },
  async postUpdateSectorMantleConfig(sector_uuid: string, payload: any): Promise<any> {
    // mantle_uuid: guid

    return await api(
      HTTP_TYPES.POST,
      `${import.meta.env.VITE_DEPOT_API_COMPANIES}/sectors/${sector_uuid}/update-mantle-config`,
      payload,
      undefined,
      'application/json',
      API_VERSION
    )
  },
  async postSectorsSync(): Promise<any> {
    return await api(
      HTTP_TYPES.POST,
      `${import.meta.env.VITE_DEPOT_API_COMPANIES}/sectors/sync`,
      undefined,
      undefined,
      'application/json',
      API_VERSION
    )
  },
}

export default response
